import React from "react";
import { useNavigate } from "react-router-dom";
import LeftArrow from "../../assets/LeftArrow";

const BackButton = () => {
  const navigate = useNavigate();

  return (
    <button
      title="Back"
      className="text-secondary"
      onClick={() => navigate(-1)}
    >
      <LeftArrow />
    </button>
  );
};

export default BackButton;
